<mat-slider
  [min]="min"
  [max]="max"
  [step]="step"
  [formControl]="sliderInput"
  [hfColor]="hfColor"
  (change)="doInput()"
  (blur)="doBlur()">
</mat-slider>
